import Vue from "vue";
import App from "./App.vue";
import AOS from "aos";
import "aos/dist/aos.css";
import vuetify from "./plugins/vuetify";
// import router from "./router";
import LazyLoadDirective from "./directives/LazyLoadDirective";

Vue.config.productionTip = false;
export const bus = new Vue();
Vue.directive("lazyload", LazyLoadDirective);

new Vue({
  created() {
    AOS.init({
      useClassNames: true,
      initClassName: false,
      animatedClassName: "animated",
    });
  },
  vuetify,
  // router,
  render: (h) => h(App),
}).$mount("#app");
